import { render, staticRenderFns } from "./CatalogCopyView.vue?vue&type=template&id=4d5b86f4&"
import script from "./CatalogCopyView.vue?vue&type=script&lang=js&"
export * from "./CatalogCopyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports